import { render, staticRenderFns } from "./ActUpdate.vue?vue&type=template&id=0a494860&"
import script from "./ActUpdate.vue?vue&type=script&lang=js&"
export * from "./ActUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports